import { Alert, Grid, IconButton, Paper, Snackbar, Stack, useTheme } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DocumentLoading } from '../documentViewCore';
import { usePhoneMode, useWindowDimensions } from '../../hooks';
import { useFaultContentById } from '../../fetch/fetchFault';
import { parameterHelper } from '../../helpers';
import { logFeatureUsage } from '../../fetch/insightsHelper';
import { useMobileOrientation } from 'react-device-detect';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

function SlideTransition(props) {
    return <Slide {...props} direction="up" />;
}

export default function ByIdFaultView() {
    const { phoneMode, isMobile } = usePhoneMode();
    const theme = useTheme();
    const scrollViewerTop = theme.appBar.height;
    const { height: viewportHeight } = useWindowDimensions();
    const { detailId } = useParams();
    const { feature } = parameterHelper.getUrlParameters({ feature: null });
    const { data, isLoading } = useFaultContentById(detailId, feature);
    const orientation = useMobileOrientation();

    const [showRotationMessage, setShowRotationMessage] = useState(false);

    useEffect(() => {
        if (phoneMode && !orientation?.isLandscape) {
            setShowRotationMessage(true);
        } else {
            setShowRotationMessage(false);
        }
    }, [phoneMode, orientation?.isLandscape]);

    const handleCloseRotationMessage = (_event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setShowRotationMessage(false);
    };

    const iframeRef = useRef(null);
    const [frameHeight, setFrameHeight] = useState(0);

    const onLoad = () => {
        setFrameHeight(iframeRef.current.contentWindow.document.body.scrollHeight * 1.10);
    }

    useEffect(() => {
        logFeatureUsage('UfcFaultView');
        // Can't log fault viewed because we don't have a family name
        // if (!!faultDetail?.universalFaultId && !!faultDetail?.universalFailureConditionId) {
        //     console.log(faultIdentifier);
        //     logFaultView(faultIdentifier, null, true);
        // }
    }, [detailId])

    if (isLoading) {
        return (
            <DocumentLoading documentHeight={viewportHeight - 128} />
        );
    }

    const action = (
        <>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseRotationMessage}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </>
    );

    return (
        <Grid
            id='scroll-viewer'
            container
            style={{
                position: 'fixed',
                top: scrollViewerTop,
                left: 0,
                height: `calc(100vh - ${scrollViewerTop}px)`,
                overflowX: 'hidden',
                overflowY: 'auto',
                width: '100vw',
                padding: '1.5em 1em 1.5em 1em'
            }}
        >
            <Grid item xs={12} xl={12}>
                <Paper style={{ overflow: 'hidden', height: isMobile ? `calc(${frameHeight}px + 6em)` : null }}>
                    <Snackbar
                        autoHideDuration={9000}
                        open={showRotationMessage}
                        message="Please rotate your device."
                        onClose={handleCloseRotationMessage}
                        slots={{ transition: SlideTransition }}
                    >
                        <Alert severity="info">
                            <div style={{ display: 'inline-block', width: '85%' }}>
                                Please rotate your device for the best experience.
                            </div>
                            <IconButton
                                size="small"
                                aria-label="close"
                                color="inherit"
                                onClick={handleCloseRotationMessage}
                                style={{ float: 'right' }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </Alert>
                    </Snackbar>
                    <Stack direction='row' spacing={2} justifyContent='center'>
                        <iframe
                            ref={iframeRef}
                            onLoad={onLoad}
                            title={`Fault View`}
                            srcDoc={data}
                            style={{
                                height: frameHeight,
                                width: '100%',
                                margin: !phoneMode ? '0.5em' : '0',
                                border: 'none',
                                backgroundColor: '#FFF'
                            }} />
                    </Stack>
                </Paper>
            </Grid>
        </Grid>
    );
}